import { Helpers } from '../../helpers';
import { ICounty } from '../../interfaces/icounty';
import { Asset } from '../asset';
import { Lease } from '../lease';
import { State } from '../state';
import { Well } from '../well';

export class CountyBase {
  CountyId: number;
  Description: string;
  Shape: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  StateId: string | null;
  CountyCode: string | null;

  Assets_County?: Array<Asset> | null;
  Leases_County?: Array<Lease> | null;
  Wells_County?: Array<Well> | null;
  State?: State;

  constructor(item?: ICounty) {
    if (item) {

      this.CountyId = item.CountyId;
      this.Description = item.Description;
      this.Shape = item.Shape;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.StateId = item.StateId;
      this.CountyCode = item.CountyCode;

      this.Assets_County = Helpers.createClassArray(Asset, item.Assets_County);
      this.Leases_County = Helpers.createClassArray(Lease, item.Leases_County);
      this.Wells_County = Helpers.createClassArray(Well, item.Wells_County);
      this.State = new State(item.State);
    }
  }
}